import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { TpaHandlerProviderSymbol } from '@wix/thunderbolt-symbols'
import { ComponentWillMountSymbol } from 'feature-components'
import { QuickActionBar } from './quickActionBarWillMount'
import { TpaHandlerProvider } from './tpaHandlers'
import { DynamicActionsApi } from './dynamicActionsApi'
import { dynamicActionsConfig } from './dynamicActionsConfig'
import { DynamicActionsApiSymbol, DynamicActionsConfigSymbol } from './symbols'

export const page: ContainerModuleLoader = (bind) => {
	bind(ComponentWillMountSymbol).to(QuickActionBar)
	bind(TpaHandlerProviderSymbol).to(TpaHandlerProvider)
	bind(DynamicActionsApiSymbol).to(DynamicActionsApi)
	bind(DynamicActionsConfigSymbol).toConstantValue(dynamicActionsConfig)
}

export const editorPage = page
